import { render, staticRenderFns } from "./MetricList.vue?vue&type=template&id=8c9f4ab4&scoped=true"
import script from "./MetricList.vue?vue&type=script&lang=js"
export * from "./MetricList.vue?vue&type=script&lang=js"
import style0 from "./MetricList.vue?vue&type=style&index=0&id=8c9f4ab4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c9f4ab4",
  null
  
)

export default component.exports